// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"n2-z"};